import React, { FC, ReactElement } from "react";
import {
  Container,
  Paragraph,
  Heading,
  Box,
  ImageContainer,
  LeftImage,
  RightImage,
} from "./styles";
import { IHeadings } from "../type";
import { colors } from "src/variables";
import { CareerGirlImages, CareerTipImages } from "../constant";

interface IProps {
  headings: IHeadings;
  children?: React.ReactNode;
  backgroundColor?: string;
  showStickyHeader?: boolean;
}

export function highlightWordInHeading(
  heading: string,
  highlightWord: string,
  color?: string
) {
  color = color ?? colors.magenta;

  const parts = heading.split(new RegExp(`(${highlightWord})`, "i"));

  return parts.map((part, index) => {
    if (part.trim() === highlightWord.trim()) {
      return (
        <span key={index} style={{ color }}>
          {part}
        </span>
      );
    }
    return part;
  });
}

const BoxWithHeading: FC<IProps> = ({
  headings: { title = "", subTitle = "", highlightWord = "" },
  children,
  backgroundColor,
}: IProps): ReactElement => {
  return (
    <Container backgroundColor={backgroundColor}>
      <ImageContainer>
        <LeftImage src="" {...CareerTipImages} />
        <RightImage src="" {...CareerGirlImages} />
      </ImageContainer>
      <Heading>
        {highlightWordInHeading(title, highlightWord, colors.white)}
      </Heading>
      <Box>
        <Paragraph>{subTitle}</Paragraph>
      </Box>
      {children}
    </Container>
  );
};

export default BoxWithHeading;
